import { Box, Button, Grid, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

const Cell = styled(TableCell)({
    padding: '8px 8px 8px 20px'
});

const FixedButton = styled(Button)({
    width: '100%',
});

const Fields = ({
    fields,
    setFields
}) => {
    return (
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ padding: '10px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                    <Typography style={{ fontWeight: 'bold' }}>Fields</Typography>
                    <Typography variant="body2">Which fields would you like to keep or reset?</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        variant={fields.filter((a) => a.reset_enabled === false).length === 0 ? 'contained' : 'outlined'}
                        size="medium"
                        color="primary"
                        onClick={() => {
                            setFields((prevData) =>
                                prevData.map((item) => (
                                    { ...item, reset_enabled: true }
                                ))
                            );
                        }}
                    >
                        Keep All
                    </Button>
                    <Button
                        variant={fields.filter((a) => a.reset_enabled === true).length === 0 ? 'contained' : 'outlined'}
                        size="medium"
                        color="primary"
                        onClick={() => {
                            setFields((prevData) =>
                                prevData.map((item) => (
                                    { ...item, reset_enabled: false }
                                ))
                            );
                        }}
                    >
                        Reset All
                    </Button>
                </Box>
            </Box>
            <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                <TableContainer>
                    <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                        <TableHead>
                            <TableRow>
                                <Cell>Fields</Cell>
                                <Cell>Comment</Cell>
                                <Cell>Keep or Reset</Cell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fields.map((a) => (
                                <TableRow>
                                    <Cell>
                                        {a.field}
                                    </Cell>
                                    <Cell>
                                        {a?.description}
                                    </Cell>
                                    <Cell>
                                        <Box style={{ display: 'flex', gap: 5 }}>
                                            <FixedButton
                                                variant={a.reset_enabled ? 'contained' : 'outlined'}
                                                onClick={() => {
                                                    setFields((prevData) =>
                                                        prevData.map((item) =>
                                                            item.label === a.label
                                                                ? { ...item, reset_enabled: !item.reset_enabled }  // Toggle the reset_enabled value
                                                                : item
                                                        )
                                                    );
                                                }}
                                            >
                                                Keep
                                            </FixedButton>
                                            <FixedButton
                                                variant={!a.reset_enabled ? 'contained' : 'outlined'}
                                                onClick={() => {
                                                    setFields((prevData) =>
                                                        prevData.map((item) =>
                                                            item.label === a.label
                                                                ? { ...item, reset_enabled: !item.reset_enabled }  // Toggle the reset_enabled value
                                                                : item
                                                        )
                                                    );
                                                }}
                                            >
                                                Reset
                                            </FixedButton>
                                        </Box>
                                    </Cell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Grid>
    )
}

export default Fields;